export enum AutomatedDefectDetectionModel {
  AerospaceDetectron2 = 'aerospace-detectron2',
}
